module.exports = __webpack_public_path__ + "static/media/AR.d3dd9c57.svg";